import { createConsumer } from '@rails/actioncable';

class RealtimeRuntime {
  constructor() {
    this.consumer = null;
    this.connectionKey = null;
    this.generation = 0;
    this.listeners = new Set();
  }

  configure({ url, accountId } = {}) {
    const normalizedUrl = String(url || '').trim();
    const normalizedAccountId = String(accountId || '').trim();
    if (!normalizedUrl || !normalizedAccountId) {
      this.destroy();
      return null;
    }

    const nextConnectionKey = `${normalizedAccountId}:${normalizedUrl}`;
    if (this.consumer && this.connectionKey === nextConnectionKey) {
      return this.consumer;
    }

    this.destroy({ notify: false });
    this.generation += 1;
    this.connectionKey = nextConnectionKey;
    this.consumer = createConsumer(normalizedUrl);
    this.emit();
    return this.consumer;
  }

  currentConsumer() {
    return this.consumer;
  }

  currentGeneration() {
    return this.generation;
  }

  owns(consumer, generation = this.generation) {
    return this.consumer === consumer && this.generation === generation;
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  destroy({ notify = true } = {}) {
    const staleConsumer = this.consumer;
    this.consumer = null;
    this.connectionKey = null;

    try {
      staleConsumer?.disconnect?.();
    } catch {}

    if (staleConsumer && notify) this.emit();
  }

  emit() {
    this.listeners.forEach((listener) => listener());
  }
}

export const realtimeRuntime = new RealtimeRuntime();
export { RealtimeRuntime };
